




























































import mixins from 'vue-typed-mixins';
import { Permission } from '@/utils/UserUtils';
import RoleUtils, { Role } from '@/utils/RoleUtils';
import OversightUtils, { OversightOrganization } from '@/utils/OversightUtils';
import ProviderUtils, { ServiceProvider } from '@/utils/ProviderUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Partial<Permission>,
    },
    visible: {
      type: Boolean as () => boolean, // use to hide form so that it doesn't trigger any outside ValidationObserver but will maintain state
    },
  },
  computed: {
    roleOptions(): any {
      return this.roles?.map((role) => ({
        text: this.$translate(role.name),
        value: role,
      })).sort((a: any, b: any) => {
          return a.text.localeCompare(b.text) });
    },
    oversightOptions(): any {
      return this.oversightorgs?.map((oversight) => ({
        text: this.$translate(oversight.name),
        value: oversight,
      })).sort((a: any, b: any) => {
          return a.text.localeCompare(b.text) });
    },
    requireOversightOrganization(): boolean {
      return this.value.role?.type === 'oversight';
    },
    serviceproviderOptions(): any {
      return this.serviceproviders?.map((serviceprovider) => ({
        text: this.$translate(serviceprovider.name),
        value: serviceprovider,
      })).sort((a: any, b: any) => {
          return a.text.localeCompare(b.text) });
    },
    requireServiceProvider(): boolean {
      return this.value.role?.type === 'serviceprovider';
    },
  },
  data: function(): {
    roles?: Role[];
    oversightorgs?: OversightOrganization[];
    serviceproviders?: ServiceProvider[];
  } {
    return {
      roles: undefined,
      oversightorgs: undefined,
      serviceproviders: undefined,
    };
  },
  async mounted() {
    try {
      const resp = await Promise.all([
        RoleUtils.api.list(),
        OversightUtils.api.instance.list(),
        ProviderUtils.api.instance.list(),
      ]);

      this.roles = resp[0];
      if (this.value.role) {
        this.value.role = this.roles.find(
          (role) => role.id === this.value?.role?.id
        );
      }

      this.oversightorgs = resp[1];
      if (this.value.oversight) {
        this.value.oversight = this.oversightorgs.find(
          (oversight) => oversight.id === this.value?.oversight?.id
        );
      }

      this.serviceproviders = resp[2];
      if (this.value.serviceprovider) {
        this.value.serviceprovider = this.serviceproviders.find(
          (serviceprovider) =>
            serviceprovider.id === this.value?.serviceprovider?.id
        );
      }
    } catch (error) {
      this.$handleAPIError(error);
    }
  },
  watch: {
    'value.role'(newval, oldval) {
      if (this.roles) {
        this.value.role = this.roles.find(
          (role) => role.id === this.value?.role?.id
        );
      }
      if (!this.requireOversightOrganization && this.oversightorgs) {
        this.value.oversight = null; // clear oversightid when it is not required
      }
      if (!this.requireServiceProvider && this.serviceproviders) {
        this.value.serviceprovider = null; // clear oversightid when it is not required
      }
    },
    'value.oversight'(newval, oldval) {
      if (this.oversightorgs) {
        this.value.oversight = this.oversightorgs.find(
          (oversight) => oversight.id === this.value?.oversight?.id
        );
      }
    },
    'value.serviceprovider'(newval, oldval) {
      if (this.serviceproviders) {
        this.value.serviceprovider = this.serviceproviders.find(
          (serviceprovider) =>
            serviceprovider.id === this.value?.serviceprovider?.id
        );
      }
    },
  },
});
